import { render, staticRenderFns } from "./AdminCouponForBundles.vue?vue&type=template&id=72e6fdda&"
import script from "./AdminCouponForBundles.vue?vue&type=script&lang=js&"
export * from "./AdminCouponForBundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e6fdda')) {
      api.createRecord('72e6fdda', component.options)
    } else {
      api.reload('72e6fdda', component.options)
    }
    module.hot.accept("./AdminCouponForBundles.vue?vue&type=template&id=72e6fdda&", function () {
      api.rerender('72e6fdda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminCouponForBundles.vue"
export default component.exports